import { ModKeys } from "@intelligems/ig-types";
import * as rtk from "@reduxjs/toolkit";
import { type PayloadAction } from "@reduxjs/toolkit";

import { initialPersonalizationStateSlice } from "../types/personalizationState";

const personalizationStateSlice = rtk.createSlice({
  name: "personalizationState",
  initialState: initialPersonalizationStateSlice,
  reducers: {
    resetPersonalizationState: (draft) => {
      draft = initialPersonalizationStateSlice;
      return draft;
    },
    setStateIssues: (
      draft,
      action: PayloadAction<{
        error: boolean;
        key: string;
        type: "warning" | "error";
        customMessage?: string;
        docLink?: string;
      }>
    ) => {
      if (action.payload.type === "warning") {
        if (action.payload.error) {
          if (
            !draft.warnings.map((arr) => arr.key).includes(action.payload.key)
          ) {
            draft.warnings.push({
              key: action.payload.key,
              customMessage: action.payload.customMessage,
              docLink: action.payload.docLink,
            });
          }
        } else {
          const index = draft.warnings.findIndex(
            (err) => err.key === action.payload.key
          );
          if (index !== -1) {
            draft.warnings.splice(index, 1);
          }
        }
      } else {
        if (action.payload.error) {
          if (
            !draft.errors.map((arr) => arr.key).includes(action.payload.key)
          ) {
            draft.errors.push({
              key: action.payload.key,
              customMessage: action.payload.customMessage,
              docLink: action.payload.docLink,
            });
          }
        } else {
          const index = draft.errors.findIndex(
            (err) => err.key === action.payload.key
          );
          if (index !== -1) {
            draft.errors.splice(index, 1);
          }
        }
      }

      return draft;
    },
    setIssuesCollapsed: (
      draft,
      action: PayloadAction<{ key: "warning" | "error"; value: boolean }>
    ) => {
      draft.issuesCollapsed[action.payload.key] = action.payload.value;
      return draft;
    },
    setModActivated: (draft, action: PayloadAction<{ key: ModKeys }>) => {
      const index = draft.activatedModArr.indexOf(action.payload.key);
      if (index > -1) {
        draft.activatedModArr.splice(index, 1);
      } else {
        draft.activatedModArr.push(action.payload.key);
      }
      return draft;
    },
    setBatchModsActivated: (
      draft,
      action: PayloadAction<{ mods: ModKeys[] }>
    ) => {
      draft.activatedModArr = action.payload.mods;
      return draft;
    },
  },
  selectors: {
    selectedIssuesCollapsed: (state) => state.issuesCollapsed,
    selectedStateErrors: (state) => state.errors,
    selectedStateWarnings: (state) => state.warnings,
    selectedActivatedModArray: (state) => state.activatedModArr,
  },
});

export const {
  resetPersonalizationState,
  setIssuesCollapsed,
  setStateIssues,
  setModActivated,
  setBatchModsActivated,
} = personalizationStateSlice.actions;

export const personalizationStateReducer = personalizationStateSlice.reducer;
export const {
  selectedIssuesCollapsed,
  selectedStateErrors,
  selectedStateWarnings,
  selectedActivatedModArray,
} = personalizationStateSlice.selectors;
